import React, { useEffect, useState } from "react";
import CommonService from "../../services/CommonService";
import Loadspinner from "../Loadspinner";
import "./SearchBar/Searchbar.css";
import { Modal } from "@material-ui/core";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect, useHistory } from "react-router";
// import * as images from "../../constants/Images";
import { useDispatch, useSelector } from "react-redux";
import { searchFilterData, resetSearchFilterData } from "../../redux/actions";
import { analytics } from "../../firebase";
import { logEvent } from 'firebase/analytics'
import { getCommonDropdownData } from "../../helpers/API/APIEndPoints";
import { APICall } from "../../helpers/API/APICalls";
import moment from "moment";
import CommonConstants from "../../constants/CommonConstants";


export function SearchMenu(props) {
  // const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  // const searchValue = new URLSearchParams(location.search).get('q')
  // const searchdata = searchValue?JSON.parse(searchValue) : null
  const { search: searchdata } = useSelector(state => state.searchFilterReducer)

  const [searchWord, setWord] = useState(searchdata?.search);
  // const [searchData, setsearchData] = useState([]);
  // const [searchbyData, setsearchbyData] = useState(false);
  const [searchbyKeyword, setSearchbyKeyword] = useState(false);
  const [platformList, setPlatformList] = useState([]);
  const [systemList, setSystemList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [showModal, setModal] = useState(true);
  const [startDate, setStartDate] = useState(searchdata?.created_date ? new Date(searchdata.created_date[0]) : '');
  const [stopDate, setStopDate] = useState(searchdata?.created_date ? new Date(searchdata.created_date[1]) : '');
  const [creatorList, setCreatorList] = useState([]);
  const [creators, setFilteredCreator] = useState(searchdata?.creators || {});


  // useEffect(() =>{
  //   if(searchdata){
  //     setStartDate(new Date(searchdata.created_date[0]))
  //     setStopDate(new Date(searchdata.created_date[1]))
  //   }
  // })

  useEffect(() => {
    setLoading(true);

    getPlatform();
    getSystem();
  }, []);


  const closeModal = () => {
    setModal(false);
    props.handleModal(false);
  };

  const handleWord = (e) => {
    setWord(e.target.value);
    setLoading(false);
  };

  const getInfoBySearch = () => {
    if (searchWord == "") {
      setSearchbyKeyword(false);
    } else {
      setSearchbyKeyword(true);
    }
  };

  if (searchbyKeyword && searchWord != "") {
    return (
      <Redirect
        to={{
          pathname: "/search",
          state: {
            searchWord: searchWord,
            // searchData: searchData,
            isKeyword: searchbyKeyword,
          },
        }}
      />
    );
  }


  //creator

  const getCreators = async (word) => {
    if (word == "") {
      word = null;
    }
    let searchFilter = {
      creator: word,
    };
    setLoading(true);
    const res = await CommonService.getCreatorList(searchFilter);
    if (res) {
      res.map((item) => (item.isSelected = false));
      setCreatorList(res);
    }
    setLoading(false);
  };

  const setFilterSearch = (e) => {
    getCreators(e.target.value);
  };

  //platform

  const getPlatform = async () => {
    const res = await CommonService.getPlatformList("");
    if (res) {
      res.map((item) => {
        if (searchdata && searchdata.platform_id.includes(item.id)) {
          item.isSelected = true
        } else {
          item.isSelected = false
        }
        return item;
      });
      setPlatformList(res);
    }
  };

  const setPlatformUnchecked = (id) => {
    let platformLists = platformList;
    platformLists.map((item) =>
      item.id == id ? (item.isSelected = !item.isSelected) : null
    );
    setPlatformList(platformLists);
  };

  //system

  const getSystem = async () => {
    //const res = await CommonService.getSystemList("");
    let requestParams = {
      dropdownName: "allCoeCommonDropdown",
      searchText: 2,
    };
    const res = await APICall(getCommonDropdownData, requestParams, "POST");
    if (res && res?.message == "Ok") {
      res?.data?.map((item) => {
        if (searchdata && searchdata.system_id.includes(item.id)) {
          item.isSelected = true
        } else {
          item.isSelected = false
        }
        item.id = item.value;
        item.system_desc = item.label;
        return item;
      });
      setSystemList(res?.data);
    }
    setLoading(false);
  };

  const setSystemUnchecked = (id) => {
    let systemLists = systemList;
    systemLists.map((item) =>
      item.id == id ? (item.isSelected = !item.isSelected) : null
    );
    setSystemList(systemLists);
  };

  const reset = () => {
    setWord("");
    setStartDate("");
    setStopDate("");
    setFilteredCreator({});
    document
      .querySelectorAll("input[type=checkbox]")
      .forEach((el) => (el.checked = false));
    let platform = platformList;
    let system = systemList;

    platform.map((item) => {
      item.isSelected = false;
    });

    system.map((item) => {
      item.isSelected = false;
    });
    setPlatformList(platform);
    setSystemList(system);
    dispatch(resetSearchFilterData())
    history.replace('/home')
  };

  const setData = () => {
    let creatorName = "";
    if (JSON.stringify(creators) !== "{}") {
      creatorName = creators.creator;
    }
    let platformsList = platformList.filter(
      (platform) => platform.isSelected == true
    );
    let systemsList = systemList.filter((system) => system.isSelected == true);
    let platforms = [];
    let systems = [];
    let date = [startDate, stopDate];
    if ((startDate.length === 0) && (stopDate.length === 0)) {
      date = null;
    } else if (stopDate == 0) {
      date = [startDate, startDate];
    } else if (startDate == 0) {
      date = [stopDate, stopDate];
    }
    try {
      date[0] = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
      date[1] = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
    } catch (err) { }

    platformsList.map((platform) => platforms.push(platform.id));
    systemsList.map((system) => systems.push(system.id));

    if (
      creatorName != "" ||
      date != null ||
      platforms?.length > 0 ||
      systems?.length > 0 ||
      searchWord?.length > 0
    ) {
      let searchData = {
        creator: creatorName,
        created_date: date,
        platform_id: platforms,
        system_id: systems,
        search: searchWord
      };

      props.setSearchData({ ...searchData, creators });
      dispatch(searchFilterData({ ...searchData, creators }))
      //logEvent(analytics(), 'filterSearch')

      closeModal();
    }
  };


  return (
    <div>
      <Modal
        open={showModal}
        onClose={closeModal}
        className="justify-space-around modal-dialog modal-dialog-scrollable"
      >
        <div>
          <Loadspinner filename="SearchComponent.js" isLoading={isLoading} isMiddle="true" />
          <div className="modal-content" style={{ width: "50vw" }}>
            <div className="modal-header">
              <h5 className="modal-title">Search Filter</h5>
              <button
                className="btn btn-close "
                type="button"
                onClick={closeModal}
              ></button>
            </div>

            <div className="modal-body" style={{ padding: "30px" }}>
              <div className=" display-col">
                <div>
                  <div>
                    <input

                      type="text"
                      style={{ width: "100%" }}
                      placeholder="Search"
                      onChange={handleWord}
                      value={searchWord}
                      autoComplete={CommonConstants.autoCompleteInput}

                    />
                    <button
                      className="btn search-btn"
                      type="button"
                      onClick={getInfoBySearch}
                    >
                      {/* <img src={images.search} className="search-icons" /> */}
                    </button>
                  </div>
                </div>
                <div className="" style={{ marginBottom: "20px" }}>
                  <h6>Creator</h6>
                  <input
                    type="text"
                    style={{ width: "100%" }}
                    onChange={setFilterSearch}
                    disabled={JSON.stringify(creators) !== "{}"}
                    autoComplete={CommonConstants.autoCompleteInput}


                  />
                  {JSON.stringify(creators) !== "{}" ? (
                    <p className="card-body creator-card">
                      <span>{creators.creator} </span>
                      <span
                        style={{ cursor: "pointer", float: "right" }}
                        onClick={() => setFilteredCreator({})}
                      >
                        X
                      </span>
                    </p>
                  ) : null}
                  {creatorList.length > 0 && JSON.stringify(creators) === "{}"
                    ? creatorList.map((creator) => (
                      <p
                        onClick={() => {
                          if (JSON.stringify(creators) === "{}") {
                            setFilteredCreator(creator);
                          }
                        }}
                        key={creator.created_by_id}
                        style={{ cursor: "pointer" }}
                      >
                        {creator.creator}
                      </p>
                    ))
                    : null}
                </div>
                <div className="" style={{ marginBottom: "20px" }}>
                  <h6>Date</h6>
                  <div className="display-row" style={{ width: "40vw" }}>
                    <div className="display-col" style={{ marginRight: "6vw" }}>
                      <h6>From</h6>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        minDate={new Date("01-01-2021")}
                        maxDate={new Date()}
                        placeholderText="Select date"
                        className="search-date"
                      />
                    </div>
                    <div className="display-col">
                      <h6>To</h6>
                      <DatePicker
                        selected={stopDate}
                        onChange={(date) => setStopDate(date)}
                        minDate={startDate}
                        maxDate={new Date()}
                        placeholderText="Select date"
                        className="search-date"
                      />
                    </div>
                  </div>
                </div>
                <div className="display-row ">
                  <div className="">
                    <h6>Platform</h6>
                    {platformList.length == 0
                      ? null
                      : platformList.map((platform) => {
                        let reqId = `platform${platform.id}`;
                        return (
                          <div key={platform.id}>
                            <input
                              type="checkbox"
                              className="form-check-input search-popup-checkbox"
                              id={reqId}
                              onChange={() =>
                                setPlatformUnchecked(platform.id)
                              }
                              defaultChecked={searchdata?.platform_id.includes(platform.id)}
                              autoComplete={CommonConstants.autoCompleteInput}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={reqId}
                            >
                              {platform.platform_desc}
                            </label>
                          </div>
                        );
                      })}
                  </div>
                  <div style={{ marginLeft: "16vw" }} className="">
                    <h6>CoE</h6>
                    {systemList.length == 0
                      ? null
                      : systemList.map((system) => {
                        let reqId = `system${system.id}`;
                        return (
                          <div key={system.id}>
                            <input
                              type="checkbox"
                              className="form-check-input search-popup-checkbox"
                              id={reqId}
                              onChange={() => setSystemUnchecked(system.id)}
                              defaultChecked={searchdata?.system_id.includes(system.id)}
                              autoComplete={CommonConstants.autoCompleteInput}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={reqId}
                            >
                              {system.system_desc}
                            </label>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer display-row justify-space-between">
              <p className="resetSearch" disabled={isLoading} onClick={reset}>
                Reset
              </p>
              <button
                className="btn btn-danger search-modal-btn"
                type="button"
                onClick={setData}
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default SearchMenu;

SearchMenu.propTypes = {
  handleModal: PropTypes.func,
  setSearchData: PropTypes.func,


};
